import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Logo from '@/components/logo';

/**
 * Persistent Agavi brand → home. Full lockup on tablet/desktop, mark-only on phone to save width.
 *
 * `onNavigate` lets an editor route the click through its unsaved-changes guard. It matters more
 * than it looks: the logo is the one exit that was NEVER guarded, and it used to be the least
 * prominent way out. Now that the editors' back chevrons are gone — they duplicated a crumb — it
 * is a primary one, so an unguarded logo would be the easiest way to lose an in-flight save's
 * `contentRevision` reconciliation.
 */
export default function NavBrand({ className = 'h-7', onNavigate }: {
  className?: string;
  onNavigate?: (to: string) => void;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <button
      onClick={() => (onNavigate ? onNavigate('/app') : navigate('/app'))}
      className='flex shrink-0 items-center rounded-lg p-1 hover:bg-ws-hover'
      aria-label={t('nav.brandHome')}
    >
      <Logo className={`hidden w-auto sm:block ${className}`} />
      <Logo markOnly className={`w-auto sm:hidden ${className}`} />
    </button>
  );
}
